import React from 'react'
import PropTypes from 'prop-types'
import { ManagerDashboardFilterValues } from 'types'
import {
  MANAGER_DASHBOARD_SECTIONS_CONFIG,
  MANAGER_DASHBOARD_DEFAULT_FILTER_VALUES,
  ORDER_TYPE_LABELS_BY_ORDER_TYPE_MAP,
} from '../constants'

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filterValues: ManagerDashboardFilterValues,
  onFilterChange: PropTypes.func.isRequired,
  appliedCount: PropTypes.number.isRequired,
}

function AdvancedFiltersPanel({
  isOpen,
  onClose,
  filterValues = MANAGER_DASHBOARD_DEFAULT_FILTER_VALUES,
  onFilterChange,
  appliedCount,
}) {
  const { list, location, city, orderType } = filterValues

  // Fully controlled by `filterValues`. Every field applies immediately, so
  // there is no local copy that can fall out of step with the applied filters
  // or be resurrected by a pending update after the user clears them.
  const handleChange = (field) => (e) => {
    onFilterChange({ ...filterValues, [field]: e.target.value })
  }

  if (!isOpen) return null

  return (
    <>
      <div
        className="manager-dashboard__filters-backdrop"
        aria-hidden
        onClick={onClose}
      />
      <aside className="manager-dashboard__filters-panel" aria-label="Filter">
        <div className="manager-dashboard__filters-panel-top">
          <button
            type="button"
            className="manager-dashboard__filters-panel-close"
            aria-label="Close filter"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="manager-dashboard__filters-panel-header">
          <h2 className="manager-dashboard__filters-panel-title">Filter</h2>
          <span className="manager-dashboard__filters-panel-applied">
            <span className="manager-dashboard__filters-panel-applied-badge">
              {appliedCount}
            </span>
            {appliedCount === 1 ? 'FILTER' : 'FILTERS'} APPLIED
          </span>
        </div>
        <div className="manager-dashboard__filters-panel-body">
          <div className="manager-dashboard__filters-field">
            <label
              htmlFor="filter-list"
              className="manager-dashboard__filters-label"
            >
              List
            </label>
            <select
              id="filter-list"
              className="manager-dashboard__filters-input"
              value={list}
              onChange={handleChange('list')}
            >
              <option value="">Select list</option>
              {MANAGER_DASHBOARD_SECTIONS_CONFIG.map((section) => (
                <option key={section.id} value={section.id}>
                  {section.title}
                </option>
              ))}
            </select>
          </div>

          <div className="manager-dashboard__filters-field">
            <label
              htmlFor="filter-location"
              className="manager-dashboard__filters-label"
            >
              Location
            </label>
            <input
              id="filter-location"
              type="text"
              className="manager-dashboard__filters-input"
              value={location ?? ''}
              onChange={handleChange('location')}
              placeholder=""
            />
          </div>

          <div className="manager-dashboard__filters-field">
            <label
              htmlFor="filter-city"
              className="manager-dashboard__filters-label"
            >
              City
            </label>
            <input
              id="filter-city"
              type="text"
              className="manager-dashboard__filters-input"
              value={city ?? ''}
              onChange={handleChange('city')}
            />
          </div>

          <div className="manager-dashboard__filters-field">
            <label
              htmlFor="filter-order-type"
              className="manager-dashboard__filters-label"
            >
              Order-Type
            </label>
            <select
              id="filter-order-type"
              className="manager-dashboard__filters-input"
              value={orderType}
              onChange={handleChange('orderType')}
            >
              <option value="">Select Order Type</option>
              {Object.entries(ORDER_TYPE_LABELS_BY_ORDER_TYPE_MAP).map(
                ([orderType, orderTypeLabel]) => (
                  <option key={orderType} value={orderType}>
                    {orderTypeLabel}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
      </aside>
    </>
  )
}

AdvancedFiltersPanel.propTypes = propTypes

export default AdvancedFiltersPanel
